import type { MailingList, RecipientList, RecipientListId } from 'types/list'
import type { State } from 'types/redux'
/**
 * Gets all email groups from the state.
 * @param state - The Redux state
 * @returns Array of email group (recipient list) objects
 */
export const getEmailGroups = (state: State): RecipientList[] =>
  state.emailGroups.emailGroups
// mailing list summaries - id, name and sender fields, no recipients
export const getMailingLists = (state: State): MailingList[] =>
  state.emailGroups.mailingList
// ids whose individual fetch failed, so load gates can stop waiting on them
export const getFailedEmailGroupIds = (state: State): RecipientListId[] =>
  state.emailGroups.failedEmailGroupIds
/**
 * Gets a specific email group by ID.
 * @param state - The Redux state
 * @param props - Object containing the list ID
 * @param props.listId - The email group ID to retrieve
 * @returns The email group object, or null/undefined if not found
 */
export const getEmailGroup = (
  state: State,
  {
    listId,
  }: {
    listId: RecipientListId
  },
): RecipientList | null | undefined =>
  state.emailGroups.emailGroups.find(group => group.id === listId)
